import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
const ReactPopover = lazy(() => import('react-popover'));
/** @deprecated use FancyPopup */
function Popover(props) {
    return (_jsx(Suspense, { fallback: null, children: _jsx(ReactPopover, { ...props, enterExitTransitionDurationMs: 0 }) }));
}
export default Popover;
